module.exports = __webpack_public_path__ + "media/assets/Undo-854787e4cf350b89eba5da378fd52fb5.svg";